<template>
  <li class="reference"><slot /></li>
</template>
<script>
export default {
  name: 'Reference'
}
</script>
<style lang="scss" scoped>
@import '../scss/mixins';
.reference {
  font-weight: 300;
  font-size: px2rem(11);
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Reference.vue